import { Divider as PrimeDivider } from 'primereact/divider';

interface DividerProps {
  text?: string;
}

export const Divider = ({ text }: DividerProps) => {
  return <PrimeDivider align='center'>{text && <b>{text}</b>}</PrimeDivider>;
};
